import React from "react";

export const PinLogo: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1"
      id="Ebene_1"
      x="0"
      y="0"
      viewBox="0 635.7 595.3 206.4"
      width="150"
      height="60"
      enableBackground="new 0 635.7 595.3 206.4"
      xmlSpace="preserve"
    >
      <defs>
        <rect id="SVGID_1_" y="635.8" width="120" height="42" />
      </defs>
      <clipPath id="SVGID_2_">
        <use xlinkHref="#SVGID_1_" overflow="visible" />
      </clipPath>
      <path
        clipPath="url(#SVGID_2_)"
        fill="#c9c8c7"
        d="M149.3 706.7H56.7c-9.8 0-15.8 3.2-16.9 9.5L30 764.7c-2 7.1 5.1 9.5 12.2 9.5H149c9.8 0 15.8-3.2 16.5-9.5l7.5-35.5 33.9-22.5 -17.3 81.9H24.8c-19.3 0-27.2-9.5-24-24L11 716.2c2.8-14.6 9.8-24 33.9-24h126.5"
      />
      <defs>
        <rect id="SVGID_3_" y="635.8" width="595.3" height="206" />
      </defs>
      <clipPath id="SVGID_4_">
        <use xlinkHref="#SVGID_3_" overflow="visible" />
      </clipPath>
      <path
        clipPath="url(#SVGID_4_)"
        fill="#c9c8c7"
        d="M258.8 692.2h91.8c19.3 0 26.8 9.5 24 24l-10.2 48.5c-3.2 14.6-9.8 24-34.3 24h-28.8l2.8-14.6h5.1c9.5 0 15-3.2 16.5-9.5l9.8-48.5c2-7.5-4.7-9.5-12.2-9.5h-29.2l-28.8 135.5h-38.6M437.7 671.7c-10.2-2-16.9-11.8-15-21.7 2.4-9.8 12.2-16.2 22.8-13.8 9.8 2 16.5 11.8 14.6 21.7C457.4 668.1 447.5 674 437.7 671.7M115 754.8c-12.6 8.7-21.3 11.8-30.7 0.8L50 715.8h38.6l19.3 22.1c3.9 4.3 5.5 4.7 12.6 0l70.1-46.1H210L115 754.8zM421.9 788.7c-19.3 0-26.8-9.5-23.6-24l12.2-57.9h-14.6l3.2-14.6h53.2l-15 72.5c-1.6 7.1 5.1 9.5 12.6 9.5h19.3l17.3-81.9h81.9c19.7 0 27.2 9.5 24 24l-12.2 57.9h14.6l-3.2 14.6h-53.2l15.8-72.5c1.6-7.5-5.1-9.5-12.2-9.5h-19.7L505 788.7H421.9L421.9 788.7z"
      />
      <polyline
        fill="#c9c8c7"
        points="496 841.9 490.9 841.9 494.4 819.8 483.4 838.3 478.3 838.3 474.3 819.8 468.8 841.9 463.7 841.9 471.6 812.7 478.3 812.7 482.6 832 493.6 812.7 500.3 812.7 "
      />
      <path
        fill="#c9c8c7"
        d="M525.9 831.2l-2.4-12.6 -7.1 12.6M533.4 841.9h-6.3l-0.8-7.1h-11.8l-4.3 7.1h-5.5l17.3-29.2h5.5L533.4 841.9z"
      />
      <polyline fill="#c9c8c7" points="548 841.9 542.5 841.9 548.4 812.7 554.3 812.7 " />
      <polyline fill="#c9c8c7" points="580.7 841.9 560.6 841.9 566.9 812.7 572 812.7 566.9 837.9 581.5 837.9 " />
    </svg>
  );
};
